<template>
  <FieldBox :title="$t('trade.order-stp-price-label')" class="stp-price">
    <PlusMinusInput
      v-model="stpPrice"
      :step="minTick"
      :min="0"
      :max="999999999"
      :precision="precision"
      :match-tick="true"
      :match-precision="true"
    />
    <p class="stp-hint">
      {{ $t('trade.order-stp-price-hint') }}
    </p>
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'
import getPriceMinTick from 'utils/getPriceMinTick'
import getPriceAccuracy from 'utils/getPriceAccuracy'

export default {
  name: 'OrderStpPriceField',
  components: {
    FieldBox,
    PlusMinusInput
  },
  props: {
    minTicks: Array
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    orderType() {
      return this.order.orderType
    },
    minTick() {
      return getPriceMinTick(this.stpPrice, this.minTicks)
    },
    precision() {
      return getPriceAccuracy(this.minTick)
    },
    stpPrice: {
      get() {
        return this.order.stpPrice
      },
      set(stpPrice) {
        this.$store.dispatch('updateTradeOrder', { stpPrice })
      }
    }
  }
}
</script>
<style scoped>
.stp-hint {
  margin-top: 5px;
  color: #838d9e;
  text-align: left;
  font-size: 12px;
}
</style>
